var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.b()},[_c('deal-select',{attrs:{"label":"Buscar negociación","placeholder":"Nombre del cliente","return-object":""},on:{"input":_vm.onInput}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }